import { apiInstance } from "./api"

const endpoint = "/tax"

export const getAllTaxes = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}